import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function changeCurrentDate(currentDate: string): RootActionTypes {
  return {
    type: ActionTypes.CHANGE_CURRENT_DATE,
    payload: currentDate,
  };
}
